<template>
    <div class="main-container main-content-container">
        <header class="header">
            <headerComponent/>
        </header>
        <nav :class="['navigation-section', {'active': navigationMode}]">
            <button @click="toggleNavigation" class="close-button">
                <img src="@/assets/images/navigationImages/closeButton.svg" alt="burger-menu" style="width: 30px; height: 30px;">
            </button>
            <navigationComponent/>
        </nav>
        <section class="page-wrapper">
            <router-view/>
        </section>
    </div>
</template>
<script>
import headerComponent from "@/components/headerComponent.vue"
import navigationComponent from "@/components/navigationComponent.vue"
import { mapGetters } from "vuex";

export default {
    components: {
        headerComponent,
        navigationComponent,
    },
    computed: {
        ...mapGetters({
            navigationMode: "getNavMode"
        })
    },
    methods: {
        toggleNavigation(){
            this.$store.dispatch("toggleNavigation");
        },
    },
    beforeRouteUpdate(to, from, next){
        this.$store.dispatch("setNavigationMode", false);
        next();
    }
}

</script>
<style scoped>
.main-content-container{
    display: grid;
    grid-template-columns: min-content auto;
    grid-template-rows: 50px auto;
}
.header{
    grid-column: 2 / 3;
    height: min-content;
    width: 100%;
}
.navigation-section{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 1em;
    z-index: 99;
    position: sticky;
    padding: 3.5em 0.6em 2.5em 1.5em;
    top: 0;
    left: 0;
    height: 100dvh;
    grid-column: 1 / 2;
    grid-row: 1 / 3;
    background-color: var(--secondary-background-color);
    transition: all 0.2s ease-out;
}
.page-wrapper{
    padding: 2em 2.5em 1em 2em ;
    grid-column: 2 / 3;
    grid-row: 2 / 3;
}
.close-button{
    display: none;
}
@media screen and (max-width: 1560px) {
    .navigation-section{
        padding: 3.5em 0.2em 1.5em 1em;
    }
    .page-wrapper{
        padding: 2em 1.5em 1em 1em ;
    }
}

@media screen and (max-width: 1700px) {
    /* .main-content-container{
        position: relative;
    } */
    .navigation-section{
        position: fixed;
        padding: 1em 0.6em 2.5em 1.5em;
        bottom: 0;
        left: 0;
        width: min-content;
        grid-column: 1 / 2;
        grid-row: 1 / 3;
        height: 100dvh;
        /* grid-column: 1 / 3;
        grid-row: 1 / 3; */
        background-color: var(--secondary-background-color);
        transform: translateX(-100%);
    }
    .navigation-section.active{
        position: fixed;
        top: 0;
        left: 0;
        width: min-content;
        height: 100dvh;
        transform: translateX(0);
    }
    .header{
        grid-column: 1 / 3;
        grid-row: 1 / 2;
        height: min-content;
        width: 100%;
    }
    .page-wrapper{
        padding: 2em 2.5em 1em 2em ;
        grid-column: 1 / 3;
        grid-row: 2 / 3;
    }
    .close-button{
        display: block;
    }
}
</style>